// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   U4Rad AI Vitals - App.css
   Modern Medical AI Platform Theme
   ============================================ */

/* Reset */
*, *::before, *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #F8FAFC;
  color: #0F172A;
}


/* ============================================
   App Root
   ============================================ */

.app-root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #F8FAFC;
}


/* ============================================
   Header
   ============================================ */

.app-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid #E2E8F0;
}

.header-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0.875rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.header-back {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 0.5rem;
  border: 1px solid #E2E8F0;
  background: #fff;
  color: #475569;
  cursor: pointer;
  transition: all 0.2s ease;
}

.header-back:hover {
  background: #F1F5F9;
  border-color: #CBD5E1;
  color: #0F766E;
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.brand-text {
  display: flex;
  flex-direction: column;
}

.brand-name {
  font-size: 1.125rem;
  font-weight: 700;
  color: #0F172A;
  letter-spacing: -0.3px;
  line-height: 1.2;
}

.brand-tag {
  font-size: 0.75rem;
  color: #0D9488;
  font-weight: 500;
}

.header-brand-sm {
  gap: 0.5rem;
}

.brand-name-sm {
  font-size: 1rem;
}

.header-status {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.875rem;
  background: #F0FDF4;
  border: 1px solid #BBF7D0;
  border-radius: 2rem;
}

.header-status-dot {
  width: 8px;
  height: 8px;
  background: #059669;
  border-radius: 50%;
  animation: statusPulse 2s ease-in-out infinite;
}

@keyframes statusPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

.header-status-text {
  font-size: 0.8125rem;
  font-weight: 500;
  color: #059669;
}


/* ============================================
   Main Content
   ============================================ */

.app-main {
  flex: 1 1;
  padding: 2rem 1.5rem;
}

.app-main-compact {
  padding: 0;
}


/* ============================================
   Landing Page Hero
   ============================================ */

.landing-container {
  max-width: 1100px;
  margin: 0 auto;
}

.landing-hero {
  text-align: center;
  padding: 3rem 0 2.5rem;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, #F0FDF4, #CCFBF1);
  border: 1px solid #99F6E4;
  color: #0F766E;
  padding: 0.5rem 1rem;
  border-radius: 2rem;
  font-size: 0.8125rem;
  font-weight: 600;
  margin-bottom: 1.25rem;
}

.hero-title {
  font-size: 2.75rem;
  font-weight: 800;
  color: #0F172A;
  letter-spacing: -1px;
  line-height: 1.15;
  margin-bottom: 1rem;
}

.hero-highlight {
  background: linear-gradient(135deg, #0F766E, #14B8A6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-subtitle {
  font-size: 1.125rem;
  color: #64748B;
  max-width: 560px;
  margin: 0 auto;
  line-height: 1.65;
}


/* ============================================
   Navigation Grid
   ============================================ */

.navigation-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 1.25rem;
  margin-bottom: 2rem;
}

.navigation-grid-single {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
}

.nav-card {
  background: #fff;
  border-radius: 1rem;
  border: 1px solid #E2E8F0;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.nav-card:hover {
  border-color: transparent;
  box-shadow: 0 20px 40px -12px rgba(15, 118, 110, 0.12);
  transform: translateY(-4px);
}

.nav-card-accent {
  height: 4px;
  width: 100%;
}

.nav-card-accent-health {
  background: linear-gradient(90deg, #0F766E, #14B8A6);
}

.nav-card-accent-height {
  background: linear-gradient(90deg, #1E40AF, #3B82F6);
}

.nav-card-accent-face {
  background: linear-gradient(90deg, #7C3AED, #A78BFA);
}

.nav-card-inner {
  padding: 1.75rem;
}

.nav-icon-wrap {
  width: 52px;
  height: 52px;
  border-radius: 0.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.25rem;
  transition: transform 0.3s ease;
}

.nav-card:hover .nav-icon-wrap {
  transform: scale(1.08);
}

.nav-icon-health {
  background: linear-gradient(135deg, #F0FDF4, #CCFBF1);
  color: #0F766E;
}

.nav-icon-height {
  background: linear-gradient(135deg, #EFF6FF, #DBEAFE);
  color: #1E40AF;
}

.nav-icon-face {
  background: linear-gradient(135deg, #F5F3FF, #EDE9FE);
  color: #7C3AED;
}

.nav-card-content {
  margin-bottom: 1.25rem;
}

.nav-card-title {
  font-size: 1.375rem;
  font-weight: 700;
  color: #0F172A;
  margin-bottom: 0.5rem;
  letter-spacing: -0.3px;
}

.nav-card-desc {
  font-size: 0.9375rem;
  color: #64748B;
  line-height: 1.6;
  margin-bottom: 1rem;
}

.nav-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.nav-tag {
  padding: 0.3rem 0.75rem;
  background: #F1F5F9;
  border-radius: 2rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: #475569;
  transition: all 0.2s ease;
}

.nav-card:hover .nav-tag {
  background: #F0FDF4;
  color: #0F766E;
}

.nav-card:hover:nth-child(2) .nav-tag {
  background: #EFF6FF;
  color: #1E40AF;
}

.nav-card:hover:nth-child(3) .nav-tag {
  background: #F5F3FF;
  color: #7C3AED;
}

.nav-arrow {
  position: absolute;
  bottom: 1.5rem;
  right: 1.5rem;
  font-size: 1.25rem;
  color: #CBD5E1;
  transition: all 0.3s ease;
  font-weight: 300;
}

.nav-card:hover .nav-arrow {
  color: #0F766E;
  transform: translateX(4px);
}


/* ============================================
   Persistent Disclaimer
   ============================================ */

.persistent-disclaimer {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  background: #FFFBEB;
  border: 1px solid #FDE68A;
  border-radius: 0.75rem;
  padding: 1rem 1.25rem;
  margin-top: 0.5rem;
}

.persistent-disclaimer .disclaimer-icon {
  color: #D97706;
  flex-shrink: 0;
  margin-top: 2px;
}

.persistent-disclaimer p {
  font-size: 0.8125rem;
  color: #92400E;
  line-height: 1.6;
}

.persistent-disclaimer strong {
  color: #78350F;
}


/* ============================================
   Footer
   ============================================ */

.app-footer {
  border-top: 1px solid #E2E8F0;
  background: #fff;
  margin-top: auto;
}

.footer-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 1.25rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.footer-brand {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.footer-brand-name {
  font-size: 0.875rem;
  font-weight: 600;
  color: #0F172A;
}

.footer-copyright {
  font-size: 0.8125rem;
  color: #94A3B8;
}


/* ============================================
   Page Animations
   ============================================ */

.app-root {
  animation: pageFadeIn 0.4s ease;
}

@keyframes pageFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}


/* ============================================
   Responsive Design
   ============================================ */

@media (max-width: 768px) {
  .hero-title {
    font-size: 2rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .navigation-grid {
    grid-template-columns: 1fr;
    max-width: 480px;
    margin: 0 auto 2rem;
  }

  .header-inner {
    padding: 0.75rem 1rem;
  }

  .brand-name {
    font-size: 1rem;
  }

  .brand-tag {
    display: none;
  }

  .footer-inner {
    flex-direction: column;
    text-align: center;
  }

  .app-main {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 1.75rem;
  }

  .landing-hero {
    padding: 2rem 0 1.5rem;
  }

  .nav-card-inner {
    padding: 1.25rem;
  }

  .nav-card-title {
    font-size: 1.125rem;
  }

  .header-status {
    padding: 0.25rem 0.625rem;
  }

  .header-status-text {
    display: none;
  }
}


/* ============================================
   Accessibility
   ============================================ */

.nav-card:focus-visible,
.header-back:focus-visible {
  outline: 2px solid #0F766E;
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD,UAAU;AACV;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,0DAA0D;EAC1D,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;AAChB;;;AAGA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;;AAGA;;iDAEiD;;AAEjD;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,qCAAqC;EACrC,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;;AAGA;;iDAEiD;;AAEjD;EACE,SAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;;AAGA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qDAAqD;EACrD,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;;AAGA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sDAAsD;EACtD,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;;AAGA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;;AAGA;;iDAEiD;;AAEjD;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;;AAGA;;iDAEiD;;AAEjD;EACE,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;;AAGA;;iDAEiD;;AAEjD;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;AACF;;;AAGA;;iDAEiD;;AAEjD;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":["/* ============================================\r\n   U4Rad AI Vitals - App.css\r\n   Modern Medical AI Platform Theme\r\n   ============================================ */\r\n\r\n/* Reset */\r\n*, *::before, *::after {\r\n  box-sizing: border-box;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nbody {\r\n  font-family: 'Inter', system-ui, -apple-system, sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  background-color: #F8FAFC;\r\n  color: #0F172A;\r\n}\r\n\r\n\r\n/* ============================================\r\n   App Root\r\n   ============================================ */\r\n\r\n.app-root {\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background-color: #F8FAFC;\r\n}\r\n\r\n\r\n/* ============================================\r\n   Header\r\n   ============================================ */\r\n\r\n.app-header {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 100;\r\n  background: rgba(255, 255, 255, 0.85);\r\n  backdrop-filter: blur(12px);\r\n  border-bottom: 1px solid #E2E8F0;\r\n}\r\n\r\n.header-inner {\r\n  max-width: 1280px;\r\n  margin: 0 auto;\r\n  padding: 0.875rem 1.5rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.header-back {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 0.5rem;\r\n  border: 1px solid #E2E8F0;\r\n  background: #fff;\r\n  color: #475569;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.header-back:hover {\r\n  background: #F1F5F9;\r\n  border-color: #CBD5E1;\r\n  color: #0F766E;\r\n}\r\n\r\n.header-brand {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.brand-text {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.brand-name {\r\n  font-size: 1.125rem;\r\n  font-weight: 700;\r\n  color: #0F172A;\r\n  letter-spacing: -0.3px;\r\n  line-height: 1.2;\r\n}\r\n\r\n.brand-tag {\r\n  font-size: 0.75rem;\r\n  color: #0D9488;\r\n  font-weight: 500;\r\n}\r\n\r\n.header-brand-sm {\r\n  gap: 0.5rem;\r\n}\r\n\r\n.brand-name-sm {\r\n  font-size: 1rem;\r\n}\r\n\r\n.header-status {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  padding: 0.375rem 0.875rem;\r\n  background: #F0FDF4;\r\n  border: 1px solid #BBF7D0;\r\n  border-radius: 2rem;\r\n}\r\n\r\n.header-status-dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  background: #059669;\r\n  border-radius: 50%;\r\n  animation: statusPulse 2s ease-in-out infinite;\r\n}\r\n\r\n@keyframes statusPulse {\r\n  0%, 100% { opacity: 1; }\r\n  50% { opacity: 0.4; }\r\n}\r\n\r\n.header-status-text {\r\n  font-size: 0.8125rem;\r\n  font-weight: 500;\r\n  color: #059669;\r\n}\r\n\r\n\r\n/* ============================================\r\n   Main Content\r\n   ============================================ */\r\n\r\n.app-main {\r\n  flex: 1;\r\n  padding: 2rem 1.5rem;\r\n}\r\n\r\n.app-main-compact {\r\n  padding: 0;\r\n}\r\n\r\n\r\n/* ============================================\r\n   Landing Page Hero\r\n   ============================================ */\r\n\r\n.landing-container {\r\n  max-width: 1100px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.landing-hero {\r\n  text-align: center;\r\n  padding: 3rem 0 2.5rem;\r\n}\r\n\r\n.hero-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  background: linear-gradient(135deg, #F0FDF4, #CCFBF1);\r\n  border: 1px solid #99F6E4;\r\n  color: #0F766E;\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 2rem;\r\n  font-size: 0.8125rem;\r\n  font-weight: 600;\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.hero-title {\r\n  font-size: 2.75rem;\r\n  font-weight: 800;\r\n  color: #0F172A;\r\n  letter-spacing: -1px;\r\n  line-height: 1.15;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.hero-highlight {\r\n  background: linear-gradient(135deg, #0F766E, #14B8A6);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n}\r\n\r\n.hero-subtitle {\r\n  font-size: 1.125rem;\r\n  color: #64748B;\r\n  max-width: 560px;\r\n  margin: 0 auto;\r\n  line-height: 1.65;\r\n}\r\n\r\n\r\n/* ============================================\r\n   Navigation Grid\r\n   ============================================ */\r\n\r\n.navigation-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\r\n  gap: 1.25rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.navigation-grid-single {\r\n  max-width: 480px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.nav-card {\r\n  background: #fff;\r\n  border-radius: 1rem;\r\n  border: 1px solid #E2E8F0;\r\n  cursor: pointer;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.nav-card:hover {\r\n  border-color: transparent;\r\n  box-shadow: 0 20px 40px -12px rgba(15, 118, 110, 0.12);\r\n  transform: translateY(-4px);\r\n}\r\n\r\n.nav-card-accent {\r\n  height: 4px;\r\n  width: 100%;\r\n}\r\n\r\n.nav-card-accent-health {\r\n  background: linear-gradient(90deg, #0F766E, #14B8A6);\r\n}\r\n\r\n.nav-card-accent-height {\r\n  background: linear-gradient(90deg, #1E40AF, #3B82F6);\r\n}\r\n\r\n.nav-card-accent-face {\r\n  background: linear-gradient(90deg, #7C3AED, #A78BFA);\r\n}\r\n\r\n.nav-card-inner {\r\n  padding: 1.75rem;\r\n}\r\n\r\n.nav-icon-wrap {\r\n  width: 52px;\r\n  height: 52px;\r\n  border-radius: 0.875rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-bottom: 1.25rem;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.nav-card:hover .nav-icon-wrap {\r\n  transform: scale(1.08);\r\n}\r\n\r\n.nav-icon-health {\r\n  background: linear-gradient(135deg, #F0FDF4, #CCFBF1);\r\n  color: #0F766E;\r\n}\r\n\r\n.nav-icon-height {\r\n  background: linear-gradient(135deg, #EFF6FF, #DBEAFE);\r\n  color: #1E40AF;\r\n}\r\n\r\n.nav-icon-face {\r\n  background: linear-gradient(135deg, #F5F3FF, #EDE9FE);\r\n  color: #7C3AED;\r\n}\r\n\r\n.nav-card-content {\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.nav-card-title {\r\n  font-size: 1.375rem;\r\n  font-weight: 700;\r\n  color: #0F172A;\r\n  margin-bottom: 0.5rem;\r\n  letter-spacing: -0.3px;\r\n}\r\n\r\n.nav-card-desc {\r\n  font-size: 0.9375rem;\r\n  color: #64748B;\r\n  line-height: 1.6;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.nav-tags {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.nav-tag {\r\n  padding: 0.3rem 0.75rem;\r\n  background: #F1F5F9;\r\n  border-radius: 2rem;\r\n  font-size: 0.75rem;\r\n  font-weight: 500;\r\n  color: #475569;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.nav-card:hover .nav-tag {\r\n  background: #F0FDF4;\r\n  color: #0F766E;\r\n}\r\n\r\n.nav-card:hover:nth-child(2) .nav-tag {\r\n  background: #EFF6FF;\r\n  color: #1E40AF;\r\n}\r\n\r\n.nav-card:hover:nth-child(3) .nav-tag {\r\n  background: #F5F3FF;\r\n  color: #7C3AED;\r\n}\r\n\r\n.nav-arrow {\r\n  position: absolute;\r\n  bottom: 1.5rem;\r\n  right: 1.5rem;\r\n  font-size: 1.25rem;\r\n  color: #CBD5E1;\r\n  transition: all 0.3s ease;\r\n  font-weight: 300;\r\n}\r\n\r\n.nav-card:hover .nav-arrow {\r\n  color: #0F766E;\r\n  transform: translateX(4px);\r\n}\r\n\r\n\r\n/* ============================================\r\n   Persistent Disclaimer\r\n   ============================================ */\r\n\r\n.persistent-disclaimer {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.75rem;\r\n  background: #FFFBEB;\r\n  border: 1px solid #FDE68A;\r\n  border-radius: 0.75rem;\r\n  padding: 1rem 1.25rem;\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.persistent-disclaimer .disclaimer-icon {\r\n  color: #D97706;\r\n  flex-shrink: 0;\r\n  margin-top: 2px;\r\n}\r\n\r\n.persistent-disclaimer p {\r\n  font-size: 0.8125rem;\r\n  color: #92400E;\r\n  line-height: 1.6;\r\n}\r\n\r\n.persistent-disclaimer strong {\r\n  color: #78350F;\r\n}\r\n\r\n\r\n/* ============================================\r\n   Footer\r\n   ============================================ */\r\n\r\n.app-footer {\r\n  border-top: 1px solid #E2E8F0;\r\n  background: #fff;\r\n  margin-top: auto;\r\n}\r\n\r\n.footer-inner {\r\n  max-width: 1280px;\r\n  margin: 0 auto;\r\n  padding: 1.25rem 1.5rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.footer-brand {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.footer-brand-name {\r\n  font-size: 0.875rem;\r\n  font-weight: 600;\r\n  color: #0F172A;\r\n}\r\n\r\n.footer-copyright {\r\n  font-size: 0.8125rem;\r\n  color: #94A3B8;\r\n}\r\n\r\n\r\n/* ============================================\r\n   Page Animations\r\n   ============================================ */\r\n\r\n.app-root {\r\n  animation: pageFadeIn 0.4s ease;\r\n}\r\n\r\n@keyframes pageFadeIn {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n\r\n/* ============================================\r\n   Responsive Design\r\n   ============================================ */\r\n\r\n@media (max-width: 768px) {\r\n  .hero-title {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .hero-subtitle {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .navigation-grid {\r\n    grid-template-columns: 1fr;\r\n    max-width: 480px;\r\n    margin: 0 auto 2rem;\r\n  }\r\n\r\n  .header-inner {\r\n    padding: 0.75rem 1rem;\r\n  }\r\n\r\n  .brand-name {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .brand-tag {\r\n    display: none;\r\n  }\r\n\r\n  .footer-inner {\r\n    flex-direction: column;\r\n    text-align: center;\r\n  }\r\n\r\n  .app-main {\r\n    padding: 1rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .hero-title {\r\n    font-size: 1.75rem;\r\n  }\r\n\r\n  .landing-hero {\r\n    padding: 2rem 0 1.5rem;\r\n  }\r\n\r\n  .nav-card-inner {\r\n    padding: 1.25rem;\r\n  }\r\n\r\n  .nav-card-title {\r\n    font-size: 1.125rem;\r\n  }\r\n\r\n  .header-status {\r\n    padding: 0.25rem 0.625rem;\r\n  }\r\n\r\n  .header-status-text {\r\n    display: none;\r\n  }\r\n}\r\n\r\n\r\n/* ============================================\r\n   Accessibility\r\n   ============================================ */\r\n\r\n.nav-card:focus-visible,\r\n.header-back:focus-visible {\r\n  outline: 2px solid #0F766E;\r\n  outline-offset: 2px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
